import { createAction } from '@reduxjs/toolkit';

export const redirectAction = createAction('shared/redirect');
export const emptyAction = createAction('shared/empty');
